module.exports = __webpack_public_path__ + "img/bg_login.92fb8651.svg";